import React from 'react'
import { useAuth } from '../AuthContext'

const Admins = () => {
  const { user, fetchWithAuth } = useAuth()
  const [admins, setAdmins] = React.useState([])
  const [email, setEmail] = React.useState('')

  const load = React.useCallback(async () => {
    try{
      const res = await fetchWithAuth(process.env.REACT_APP_BACKEND_URL + '/api/admins')
      if (!res.ok) throw new Error('Fetch failed')
      const data = await res.json()
      setAdmins(data.admins || [])
    }catch(e){
      console.error(e)
      setAdmins([])
    }
  }, [fetchWithAuth])

  React.useEffect(() => { if (user?.token) load() }, [user?.token, load])

  const add = async (e) => {
    e.preventDefault()
    try{
      const res = await fetchWithAuth(process.env.REACT_APP_BACKEND_URL + '/api/admins', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email }) })
      if (!res.ok) throw new Error('Add failed')
      setEmail('')
      await load()
    }catch(e){
      console.error(e)
      alert('Could not add admin')
    }
  }

  const remove = async (e, addr) => {
    e.preventDefault()
    if (!confirm(`Remove admin ${addr}?`)) return
    try{
      const res = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/api/admins/${encodeURIComponent(addr)}`, { method: 'DELETE' })
      if (!res.ok) throw new Error('Remove failed')
      await load()
    }catch(e){
      console.error(e)
      alert('Could not remove admin')
    }
  }

  return (
    <div className="min-h-screen bg-soft p-6">
      <div className="container-custom mx-auto">
        <h1 className="text-2xl font-bold mb-4">Admin Management</h1>
        <form onSubmit={add} className="mb-4 flex gap-2">
          <input value={email} onChange={e=>setEmail(e.target.value)} placeholder="admin@example.com" className="px-3 py-2 border rounded flex-1" />
          <button className="px-4 py-2 bg-brand text-white rounded">Add</button>
        </form>
        <div className="bg-white p-4 rounded shadow">
          {admins.length === 0 ? <div className="text-gray-600">No admins.</div> : (
            <ul className="space-y-2">
              {admins.map(a => (
                <li key={a.email} className="p-2 border rounded flex justify-between items-center">
                  <div>{a.email}</div>
                  <div><button onClick={(e)=>remove(e,a.email)} className="px-2 py-1 border rounded">Remove</button></div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  )
}

export default Admins
